import React, { Component } from 'react';
import { MessageSourceProps, withMessages } from 'react-message-source';
import { withRouterWorkaround } from 'utils/workaroundUtils';
import { PatientConsumerRenderProps, withPatientContext } from 'components/patient/PatientContext';
import styled from 'styled-components';
import { RouterProps } from 'react-router';
import { BillReminderSearchResponse } from 'ts-types/api.types';
import ManualBillReminderSearchView from 'components/reminder/ManualBillReminderSearchView';
import ManualBillReminderTableView from 'components/reminder/ManualBillReminderTableView';
import FullScreenPageHeader from 'components/FullScreenPageHeader';
import PraxStyledSegment from 'components/layout/PraxStyledSegment';
import { Divider } from 'semantic-ui-react';

const StyledPraxSegment = styled(PraxStyledSegment)`
  margin-top: 0 !important;
  padding: 0 !important;
  margin-bottom: 5px !important;
`;

const ContentDiv = styled.div`
  flex: 1 1 auto;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

interface Props extends MessageSourceProps, PatientConsumerRenderProps, RouterProps {
}

interface State {
  billsLoading: boolean,
  bills: Array<BillReminderSearchResponse>
}

class ManualBillReminderView extends Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      bills: [],
      billsLoading: false
    }
  }

  onFilterBills = (bills: Array<BillReminderSearchResponse>) => {
    this.setState({
      bills: bills
    })
  };

  onBillsLoadingChange = (billsLoading: boolean) => {
    this.setState({
      billsLoading: billsLoading
    })
  };

  goToHome = () => {
    const {history} = this.props;

    history.push("/");
  };

  render(): React.ReactNode {

    const {bills, billsLoading} = this.state;
    const {currentPatient, getMessage, onPatientRefresh} = this.props;

    return (
        <ContentDiv>
          <FullScreenPageHeader headerMessage={getMessage("manualReminder")}
                                buttonMessage={getMessage("back")}
                                onConfirm={() => this.goToHome()}/>

          <StyledPraxSegment>
            <ManualBillReminderSearchView
                currentPatient={currentPatient}
                onFilterBills={this.onFilterBills}
                onBillsLoadingChange={this.onBillsLoadingChange}
            />
            <Divider/>
            <ManualBillReminderTableView
                bills={bills}
                billsLoading={billsLoading}
                currentPatient={currentPatient}
                onPatientRefresh={onPatientRefresh}
            />
          </StyledPraxSegment>
        </ContentDiv>
    );
  }
}

export default withRouterWorkaround(withPatientContext(withMessages(ManualBillReminderView)));
